export default __webpack_public_path__ + "static/media/development_2.c1a0876e.png";